
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("@babel/polyfill");
require('./bootstrap');
const axios = require('axios');
const bugsnag = require('@bugsnag/js');
const bugsnagVue = require('@bugsnag/plugin-vue');
import Notifications from 'vue-notification';
//import VueClipboard from 'vue-clipboard2'
import VueCroppie from 'vue-croppie';

window.Vue = require('vue');

Vue.use(Notifications);
//Vue.use(VueClipboard);
Vue.use(VueCroppie);

const bugsnagClient = bugsnag({ 
    apiKey:'01cc70d1b9f2cd82290e634ef99b5b2d',
    releaseStage: process.env.NODE_ENV
});
bugsnagClient.use(bugsnagVue, Vue);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('signature-designer', require('./components/SignatureDesigner.vue').default);
Vue.component('signature-generator', require('./components/SignatureGenerator.vue').default);
Vue.component('purchase-modal', require('./components/PurchaseModal.vue').default);
Vue.component('upgrade-modal', require('./components/UpgradeModal.vue').default);
Vue.component('file-upload', require('./components/FileUpload.vue').default);
Vue.component('signature-access-code', require('./components/SignatureAccessCode.vue').default);
Vue.component('signature-employee-email-verify', require('./components/SignatureEmployeeEmailVerify.vue').default);
Vue.component('image-modal', require('./components/ImageModal.vue').default);
Vue.component('recent-color-palette', require('./components/RecentColorPalette.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app'
});
